export enum ResidentFeature {
  INCONTINENCE_MANAGEMENT_URINE = 'Incontinence Management (Urine)',
  INCONTINENCE_MANAGEMENT_STOOL = 'Incontinence Management (Stool)',
  REPOSITIONING_MANAGEMENT = 'Repositioning Management',
  SECURE_ZONE = 'Secure Zone',
  FALL_MANAGEMENT = 'Fall Management',
}
